 document.addEventListener("DOMContentLoaded", function () {
    const scrollContainer = document.querySelector(".thumbnail_ctm_slider_list");
    const leftArrow = document.querySelector(".left-scroll-icon");
    const rightArrow = document.querySelector(".right-scroll-icon");

    const scrollAmount = 200; // Adjust this to control how much it scrolls

    if (rightArrow && leftArrow) {
      rightArrow.addEventListener("click", () => {
        scrollContainer.scrollBy({
          left: scrollAmount,
          behavior: "smooth"
        });
      });
  
      leftArrow.addEventListener("click", () => {
        scrollContainer.scrollBy({
          left: -scrollAmount,
          behavior: "smooth"
        });
      });
    }
  });
